import { useState } from 'react'
import Footer from '../component/Footer';
import Navbar from '../component/Navbar';
import '../hamcss/csr.css';

import ReactWhatsapp from "react-whatsapp";
import { FaRegFilePdf } from "react-icons/fa";
import { FloatingWhatsApp } from 'react-floating-whatsapp';
import DotRing from '../component/dot/DotRing';
import csr_charter from '../assests/sgPdf/csr/CSR-charter.pdf';
import csr_policy from '../assests/sgPdf/csr/2. CSR_Policy.pdf';
import csr1 from '../assests/CSR/2.webp';
import csr2 from '../assests/CSR/1.webp';
import csr3 from '../assests/CSR/3.webp';
import csr4 from '../assests/CSR/4.webp';
import csr5 from '../assests/CSR/IMG_8928.webp';
import csr6 from '../assests/CSR/IMG_8896.webp';
import csr7 from '../assests/CSR/IMG_1884.webp';
import csr8 from '../assests/CSR/5.webp';
import csr9 from '../assests/CSR/6.webp';
import csr10 from '../assests/CSR/7.webp';
import csr11 from '../assests/CSR/8.webp';
import csr12 from '../assests/CSR/9.webp';
import csr13 from '../assests/CSR/10.webp';
import banner from '../assests/CSR/banner.webp';
import annual_action_plan from '../assests/sgPdf/csr/CSR Annual Action Plan 26-27.pdf';


const CSR = () => {

    const [visible, setVisible] = useState('visible')
    const [selectedCsrYear, setSelectedCsrYear] = useState("fy2025");

    const handleCsrYearChange = (event) => {
        setSelectedCsrYear(event.target.value);
    };
    const handleVisible = () => {
        setVisible(true);
        setVisible1(false);
        setVisible2(false);
    }

    const [visible1, setVisible1] = useState('')

    const handleVisible1 = () => {
        setVisible(false);
        setVisible1(true);
        setVisible2(false);
    }
    const [visible2, setVisible2] = useState('')

    const handleVisible2 = () => {
        setVisible(false);
        setVisible1(false);
        setVisible2(true);
    }


    return (
        <>




            <DotRing />
            <Navbar />

            <section>
                <div
                    className="BreadArea"
                    style={{
                        backgroundImage: `url('${banner}')`,
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: 'center',
                        height: "43vh",
                    }}
                >
                    <div
                        style={{ marginTop: "30px" }}
                        className="container"
                    >
                        <h2 style={{ wordSpacing: '1px', letterSpacing: '0.2px' }}>
                            CSR Initiative
                        </h2>

                    </div>
                </div>
            </section>

            <section style={{ display: 'flex', justifyContent: 'center' }}>
                <section className="containner">

                    <div className='swith-bt'>
                        <h5 className={`swith-bt-t ${visible ? 'blue-text' : ''}`} onClick={handleVisible}>CSR Overview</h5>
                        <h5 className={`swith-bt-t ${visible1 ? 'blue-text' : ''}`} onClick={handleVisible1}>Our Gallery</h5>
                        <h5 className={`swith-bt-t ${visible2 ? 'blue-text' : ''}`} onClick={handleVisible2}>Annual Action Plan</h5>
                    </div>

                    {visible && (
                        <section className="main-csr-box">


                            <div className="inside-csr">
                                <h3 >Introduction</h3>

                                <p className="p-text-csr-1">
                                    Responsibility is the bedrock for sustainable growth. It encompasses protecting and nurturing the ecosystem, the people, and the policies which form the foundation for continual progress. Similarly, Corporate Social Responsibility (CSR) aims to contribute to the societal goals of a philanthropic activity, or a charitable nature by engaging in, with, or supporting professional service volunteering through pro-bono programs. 

                                </p>
                                <p className="p-text-csr-1">As per the Section 135 of The Companies Act 2013, provides that companies must mandatorily contribute a certain amount towards CSR activities. CSR isn't solely about profit distribution; it also encompasses the ethical considerations and practices involved in revenue generation within an organization.
                                </p>
                                <p className="p-text-csr-1">
                                SGFL is dedicated to giving back to the community through sustainable and innovative CSR activities. This CSR’s vision & mission is to build a stronger community through empowering & enlightening the lives of underprivileged Children. This is achieved through round-the-year initiatives focused on promoting Child Education.
                                </p>
                            </div>
                            <div className="inside-csr">

                                <div className="csr-year-header">

                                    <h3>
                                        Our Commitment to Children – SGFL's CSR Initiatives
                                    </h3>

                                    <select
                                        className="csr-year-select"
                                        value={selectedCsrYear}
                                        onChange={handleCsrYearChange}
                                    >
                                        <option value="fy2025">FY 2025-26</option>
                                        <option value="fy2024">FY 2024-25</option>
                                        <option value="fy2023">FY 2023-24</option>
                                    </select>

                                </div>

                                <p className="p-text-csr-1">
                                    At SG Finserve Limited, we believe that children are the foundation
                                    of a brighter tomorrow. As part of our Corporate Social Responsibility
                                    (CSR), we are dedicated to supporting underprivileged and special
                                    children through education-focused initiatives that bring real impact
                                    and lasting change.
                                </p>


                                {/* FY 2025-26 */}
                                {selectedCsrYear === "fy2025" && (
                                    <div className="csr-year-content">

                                        <h3>
                                            FY 2025-26: Supporting Education, Healthcare and Community Welfare
                                        </h3>

                                        <p className="p-text-csr-1">
                                            In FY 2025–26, our CSR initiatives focus on creating meaningful
                                            and sustainable impact through education, healthcare, skill
                                            development, and community welfare. Our ongoing project in
                                            Vrindavan, District Mathura, Uttar Pradesh, aims to develop a
                                            comprehensive community facility with provisions for Anganwadi
                                            and remedial education, a public library, skill training,
                                            old-age care, food and medical support, and animal welfare.
                                            Alongside this, our CSR initiatives support educational
                                            resources, training, digital learning and transportation,
                                            as well as medical and eye-care interventions. Through these
                                            initiatives, we remain committed to empowering underserved
                                            communities and creating access to essential services and
                                            opportunities for a better future.
                                        </p>

                                    </div>
                                )}


                                {/* FY 2024-25 */}
                                {selectedCsrYear === "fy2024" && (
                                    <div className="csr-year-content">

                                        <h3>
                                            FY 2024-25: Supporting Special Education at Renu Vidya Mandir
                                        </h3>

                                        <p className="p-text-csr-1">
                                            In FY 2025, our CSR contribution is directed towards
                                            Renu Vidya Mandir in Sonipat, a school devoted to nurturing
                                            and educating children with special needs. We are proud to
                                            stand beside this remarkable institution in creating an
                                            inclusive environment where every child’s potential is
                                            celebrated and empowered.
                                        </p>

                                    </div>
                                )}


                                {/* FY 2023-24 */}
                                {selectedCsrYear === "fy2023" && (
                                    <div className="csr-year-content">

                                        <h3>
                                            FY 2023-24: Project “VIDHYADHARA”
                                        </h3>

                                        <p className="p-text-csr-1">
                                            Our CSR journey began with Lal Bahadur Shastri Bal Vatika
                                            School in Vasundhara, Ghaziabad (run by Bharat Puria Education
                                            Society), under the initiative named VIDHYADHARA. The goal
                                            was simple yet impactful—support children from economically
                                            weaker backgrounds by providing essentials such as textbooks,
                                            uniforms, clean water, and sanitation facilities. Together,
                                            we aimed to help them dream bigger and brighter.
                                        </p>

                                    </div>
                                )}

                            </div>
                            {/*<div className="inside-csr">
                                <h3 >Our Commitment to Children – SGFL's CSR Initiatives</h3>

                                <p className="p-text-csr-1">
                                    At SG Finserve Limited, we believe that children are the foundation of a brighter tomorrow. As part of our Corporate Social Responsibility (CSR), we are dedicated to supporting underprivileged and special children through education-focused initiatives that bring real impact and lasting change. 

                                </p>
                                <h3>FY 2025-26: Supporting Education, Healthcare and Community Welfare
</h3>
                                <p className="p-text-csr-1">In FY 2025–26, our CSR initiatives focus on creating meaningful and sustainable impact 
through education, healthcare, skill development, and community welfare. Our ongoing project 
in Vrindavan, District Mathura, Uttar Pradesh, aims to develop a comprehensive community 
facility with provisions for Anganwadi and remedial education, a public library, skill training, 
old-age care, food and medical support, and animal welfare. Alongside this, our CSR initiatives 
support educational resources, training, digital learning and transportation, as well as medical 
and eye-care interventions. Through these initiatives, we remain committed to empowering 
underserved communities and creating access to essential services and opportunities for a better 
future.
                                </p>
                                <h3>FY 2024-25: Supporting Special Education at Renu Vidya Mandir</h3>
                                <p className="p-text-csr-1">In FY 2025, our CSR contribution is directed towards Renu Vidya Mandir in Sonipat, a school devoted to nurturing and educating children with special needs. We are proud to stand beside this remarkable institution in creating an inclusive environment where every child’s potential is celebrated and empowered.
                                </p>
                                <h3>FY 2023-24: Project “VIDHYADHARA”</h3>
                                <p className="p-text-csr-1">
                                Our CSR journey began with Lal Bahadur Shastri Bal Vatika School in Vasundhara, Ghaziabad (run by Bharat Puria Education Society), under the initiative named VIDHYADHARA. The goal was simple yet impactful—support children from economically weaker backgrounds by providing essentials such as textbooks, uniforms, clean water, and sanitation facilities. Together, we aimed to help them dream bigger and brighter.

                                </p>
                            </div>*/}
                           
                            <div className="inside-csr">
                                <h3 >CSR Policy</h3>

                                <p className="p-text-csr-1">
                                    SGFL strongly believes that Corporate Social Responsibility is connected with the principles of sustainable growth and hence recognizes the immense opportunity it has to bring about a positive change in the lives of the communities through its business operations and CSR activities.

                                </p>
                                
                                <p className="p-text-csr-1">As our Corporate Social Responsibility (CSR), we actively implement projects and initiatives for the betterment of society.


                                </p>
                                <div className="pdf-clas1">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={csr_policy} target='blank'><h6>CSR Policy</h6></a>
                                </div>
                               <div className="pdf-clas1">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={csr_charter} target='blank'><h6>CSR Charter</h6></a>
                                </div>
                            </div>
                            <div className="inside-csr">
                                <h3 >Key Focus Areas</h3>
                                <h4 >Education</h4>
                                <p className="p-text-csr-1">
                                   To support quality education for underprivileged children, with special emphasis on education for children from marginalized communities and to improve the standard of education by strengthening the existing infrastructure and providing basic facilities.


                                </p>
                                
                                
                               
                            </div>


                            


                        </section>
                    )}


                    {visible1 && (
                        <section className="main-csr-box">

                            <div className="key-focus">

                                <div className="key-focus-inside-2">
                                    {/* <h3>Education</h3> */}
                                    <img src={csr8} alt="sg finserve csr" />
                                </div>
                                <div className="key-focus-inside-2">
                                    {/* <h3>Education</h3> */}
                                    <img src={csr13} alt="sg finserve csr" />
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column', gap: '60px' }}>

                                    <div className="key-focus-inside-2-t">
                                        {/* <h3>Education</h3> */}
                                        <img src={csr10} alt="sg finserve csr" />
                                    </div>

                                    <div className="key-focus-inside-2-t">
                                        {/* <h3>Education</h3> */}
                                        <img src={csr11} alt="sg finserve csr" />
                                    </div>


                                </div>

                            </div>

                            <div className="key-focus">

                                <div className="key-focus-inside-2">
                                    {/* <h3>Education</h3> */}
                                    <img src={csr5} alt="sg finserve csr" />
                                </div>
                                <div className="key-focus-inside-2">
                                    {/* <h3>Education</h3> */}
                                    <img src={csr6} alt="sg finserve csr" />
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column', gap: '60px' }}>
                                    <div className="key-focus-inside-2-t">
                                    {/* <h3>Education</h3> */}
                                    <img src={csr12} alt="sg finserve csr" />
                                    </div>
                                    <div className="key-focus-inside-2-t">
                                        {/* <h3>Education</h3> */}
                                        <img src={csr7} alt="sg finserve csr" />
                                    </div>
                                    
                                </div>

                            </div>

                            
                           <div className="key-focus">

                                <div className="key-focus-inside-2">
                                    {/* <h3>Education</h3> */}
                                    <img src={csr3} alt="sg finserve csr" />
                                </div>
                                <div className="key-focus-inside-2">
                                    {/* <h3>Education</h3> */}
                                    <img src={csr4} alt="sg finserve csr" />
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column', gap: '60px' }}>

                                    <div className="key-focus-inside-2-t">
                                        {/* <h3>Education</h3> */}
                                        <img src={csr2} alt="sg finserve csr" />
                                    </div>

                                    <div className="key-focus-inside-2-t">
                                        {/* <h3>Education</h3> */}
                                        <img src={csr1} alt="sg finserve csr" />
                                    </div>


                                </div>

                            </div>
                        </section>
                    )}
                    {visible2 && (
                    <section className="main-csr-box annual-action-plan-section">

                        <div className="inside-csr annual-plan-wrapper">

                            <div className="annual-plan-heading">
                                <h3>CSR Annual Action Plan</h3>

                                
                            </div>

                            <div className="annual-plan-card">

                                <div className="annual-plan-icon">
                                    <FaRegFilePdf size={45} />
                                </div>

                                <div className="annual-plan-info">
                                    <h4>CSR Annual Action Plan – FY 2026–27</h4>

                                    <p>
                                        View the approved Annual Action Plan of
                                        SG Finserve Limited for FY 2026–27.
                                    </p>
                                </div>

                                <div className="annual-plan-actions">

                                    <a
                                        href={annual_action_plan}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="annual-plan-view-btn"
                                    >
                                        <FaRegFilePdf />
                                        View PDF
                                    </a>

                                    <a
                                        href={annual_action_plan}
                                        download
                                        className="annual-plan-download-btn"
                                    >
                                        Download PDF
                                    </a>

                                </div>

                            </div>

                        </div>

                    </section>
                )}



                    <div>
                        {/* <ReactWhatsapp number="+919791028585" message="Hello World!!!" /> */}
                        <FloatingWhatsApp phoneNumber="919205556122" accountName="Customer Care" />
                    </div>



                    <Footer />
                </section>
            </section>

        </>
    )
}

export default CSR